import { Option as TypeAheadOption } from "react-bootstrap-typeahead/types/types";

export interface ColumnFilter {
  type: FilterType;
  filterKey?: string;
  label?: string;
  placeholder?: string;
  options?: FilterOptions[];
  typeaheadOptions?: TypeAheadOptions;
  selectOptions?: SelectOptions;
}

export enum FilterType {
  TEXT = "TEXT",
  CUSTOM = "CUSTOM",
  TYPEAHEAD = "TYPEAHEAD",
  SELECT = "SELECT",
  DATE_RANGE = "DATE_RANGE",
}

export interface TypeAheadOptions {
  optionLabelKey: string | ((option: any) => string);
  optionValueKey?: string;
  isLoading: boolean;
  onSearch: (searchTerm: string) => Promise<any[]>;
  options: TypeAheadOption[];
  selected?: TypeAheadOption;
  placeholder?: string;
}

export interface SelectOptions {
  labelKey?: string;
  valueKey?: string;
  options: any[];
  operator?: "eq" | "cn";
}

export interface FilterOptions {
  value: any;
  label: string;
}
